import * as React from "react";
import { Clipboard } from "react-feather";
import { ExternalLink } from "../../newcomponents/table/components/ExternalLink";
import { DOCS_URL } from "../../envVariables";

export const SupportDocs: React.FC = () => {
  async function handleCopyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
  }

  return (
    <div className="flex justify-center gap-4 my-6">
      <div>
        <div className="font-semibold text-sm">Support Email</div>
        <div className="flex items-center gap-1">
          <a className="color-link-hover" href={`mailto:support@controlplane.com`}>
            support@controlplane.com
          </a>
          <Clipboard
            className="feather-icon cursor-pointer color-link-hover"
            onClick={() => handleCopyToClipboard(`support@controlplane.com`)}
          />
        </div>
      </div>
      <div>
        <div className="font-semibold text-sm">Documentation</div>
        <ExternalLink url={DOCS_URL} label={DOCS_URL} disableCopy />
      </div>
    </div>
  );
};
